var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAfternoonIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 52,
  viewBox: "0 0 52 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.5474 11.9551C34.4213 11.9553 40.8042 18.3389 40.8042 26.2129C40.8039 34.0866 34.4211 40.4695 26.5474 40.4697C18.6734 40.4697 12.2898 34.0868 12.2896 26.2129C12.2896 18.3388 18.6732 11.9551 26.5474 11.9551Z",
  fill: "#F9B444"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2158 4L26.2158 7.9788",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2158 44.4512L26.2158 48.43",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.4302 26.2129L44.4514 26.2129",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.979 26.2129L4.00021 26.2129",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M41.9229 10.5078L39.1094 13.3212",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3193 39.1133L10.5059 41.9267",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M41.9229 41.918L39.1094 39.1045",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3193 13.3184L10.5059 10.5049",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M34.894 5.77148L33.3398 9.43417",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0933 43.0039L17.5391 46.6666",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M46.665 34.8965L43.0024 33.3423",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M9.42773 19.0898L5.76505 17.5356",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M46.811 17.8906L43.1221 19.3815",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M9.30713 33.0488L5.61823 34.5397",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M34.54 46.8125L33.0491 43.1236",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3818 9.30664L17.8909 5.61774",
  stroke: "#F9B444",
  strokeWidth: 2.65253,
  strokeLinecap: "round"
})));
export default SvgAfternoonIcon;